function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M681.922 5001.975a20.028 20.028 0 0 1-17.842-29.075 1.5 1.5 0 1 1 2.683 1.342 17.015 17.015 0 0 0 25 21.6 1.5 1.5 0 1 1 1.721 2.457 20.073 20.073 0 0 1-11.562 3.676z",
    style: {
      fill: "#324a6d"
    },
    transform: "translate(-661.922 -4961.975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.921 4992.775a1.5 1.5 0 0 1-1.29-2.265 16.73 16.73 0 0 0 2.291-8.535 17.019 17.019 0 0 0-17-17 16.639 16.639 0 0 0-9.278 2.755 1.5 1.5 0 0 1-1.645-2.51 19.607 19.607 0 0 1 10.923-3.245 20.022 20.022 0 0 1 20 20 19.743 19.743 0 0 1-2.709 10.064 1.5 1.5 0 0 1-1.292.736z",
    style: {
      fill: "#324a6d"
    },
    transform: "translate(-661.922 -4961.975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.922 4986.975h4v13.2a15.136 15.136 0 0 0 6 0v-13.2h3.6a1.063 1.063 0 0 0 1-.9l.4-3a1.884 1.884 0 0 0-.2-.8 1.137 1.137 0 0 0-.8-.3h-4v-3.5a2.006 2.006 0 0 1 2-2h2a.945.945 0 0 0 1-1v-3.4a.987.987 0 0 0-.9-1c-.1 0-1.5-.1-3.3-.1-4.4 0-6.8 2.6-6.8 7.4v3.6h-4a.945.945 0 0 0-1 1v3a.945.945 0 0 0 1 1z",
    style: {
      fill: "#324a6d"
    },
    transform: "translate(-661.922 -4961.975)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebook.icon.66c12d57b0f1e31ae40c0b7ce4de15e1.svg";
export { ForwardRef as ReactComponent };